import React, { useState, useEffect, useRef } from "react";
import axios from "./utils/axiosConfig";
import { Table, Button, Form, Modal, ListGroup, Spinner, Alert, Card, Row, Col, Badge } from "react-bootstrap";
import { useAuth } from "./context/AuthContext";
import { hasPermission } from "./utils/permissions";
import { useSmartApi } from "./utils/apiMigrationHelper";
import { isSuperAdmin } from './utils/superAdmin';
import DatePicker from "react-datepicker";
import {
  downloadActivitiesExcel,
  handleExcelFileUpload,
  uploadActivitiesData,
  formatImportResults
} from "./utils/activityExcel";

import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import jsPDF from 'jspdf';
import PhotoUpload from './services/PhotoUpload'; // 匯入 PhotoUpload 元件
import Lightbox from 'react-image-lightbox'; // 匯入 Lightbox
import 'react-image-lightbox/style.css'; // 匯入 Lightbox 的樣式
import { useMediaQuery } from 'react-responsive'; // RWD 支援
import "jspdf/dist/jspdf.umd";
//import { useNavigate } from "react-router-dom";

import "react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css";
import "react-datepicker/dist/react-datepicker.css";

const initialFormData = {
  a_group: "",
  a_ssid: "",
  a_name: "",
  a_no: "",
  a_date: "",
  a_Sdate: "",
  a_Edate: "",
  a_date_over: "",
  a_people: 99999,
  a_location: "",
  a_remark: "",
  a_status: 0,
  a_partake: 0,
  a_stop: 0,
  a_budget: 0,
  a_notify: 0,
  a_eid: "",
  a_eid_name: "",
  topics: [],
};

const ActivitiesTable = () => {
  const navigateToNewPage = (activityId) => {
    window.open(`/JoinPage?aid=${activityId}`, "_blank");
  };
  
  const [activities, setActivities] = useState([]);
  const [mainActs, setMainActs] = useState([]); 
  const [stores, setStores] = useState([]); 
  const [employees, setEmployees] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(""); 
  const [page, setPage] = useState(1); 
  const [hasMore, setHasMore] = useState(true); 
  const { user } = useAuth();
  // 簡化權限：只有秘書能編輯
  const canEditRole = isSuperAdmin(user?.e_id) || user?.e_position === 17;
  // 匯入活動權限：只有最高權限 (e_id=80) 才能使用
  const canImportActivities = isSuperAdmin(user?.e_id);
  
  
  const [isLightboxOpen, setIsLightboxOpen] = useState(false); // 控制 Lightbox 開啟狀態
  const [lightboxImage, setLightboxImage] = useState('');      // Lightbox 顯示的圖片

  const [sortConfig, setSortConfig] = useState({
    key: "a_date",
    direction: "desc",
  });

  // 時間篩選：all（全部）、future（未來活動）、past（過去活動）- 預設為未來活動
  const [timeFilter, setTimeFilter] = useState("future");

  // 活動類別篩選
  const [categoryFilter, setCategoryFilter] = useState(""); 
  const observer = useRef(); 
  const lastActivityRef = useRef(); 
  const [showModal, setShowModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const token = useRef(localStorage.getItem("token"));
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlIsSelf = queryParams.get('self') === 'true';

  // 如果用戶是秘書，強制設為 secretary 模式
  const isSecretary = isSuperAdmin(user?.e_id) || user?.e_position === 17;
  const isSelf = urlIsSelf || isSecretary;

  // 響應式判斷：768px 以下為手機版
  const isMobile = useMediaQuery({ maxWidth: 768 });
  
  // 使用智能 API
  const { smartCall, getActivities, getUserRole } = useSmartApi();
 
  const [formData, setFormData] = useState(initialFormData);
  const [showQRCode, setShowQRCode] = useState(false); 
  const [qrCodeValue, setQRCodeValue] = useState("");  
  const [activityName, setActivityName] = useState(""); 
  const [lecturerTopics, setLecturerTopics] = useState(""); // 講師主題 
  const [showLecturerModal, setShowLecturerModal] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [lecturers, setLecturers] = useState([]);
  const [loadingLecturers, setLoadingLecturers] = useState(false); 
  const [topics, setTopics] = useState({ t_lid: "", t_name: "" }); 
  const [searchTerm, setSearchTerm] = useState(""); 
  const [filteredEmployees, setFilteredEmployees] = useState([]); 
  const [showEmployeeSuggestions, setShowEmployeeSuggestions] = useState(false); 
  const [showLecturerSuggestions, setShowLecturerSuggestions] = useState(false); 
  const [companies, setCompanies] = useState([]);  
  const [visitDetails, setVisitDetails] = useState({ v_sid: "", v_name: "" });
  const [searchCompanyTerm, setSearchCompanyTerm] = useState(""); 
  const [selectedActivityQuestions, setSelectedActivityQuestions] = useState([]); 
  const [newQuestion, setNewQuestion] = useState({ q_text: "", q_type: "1", options: [""] });
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [showCompanySuggestions, setShowCompanySuggestions] = useState(false);
  
  // Excel 相關狀態
  const [showExcelImportModal, setShowExcelImportModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [isProcessingExcel, setIsProcessingExcel] = useState(false);
  const [excelPreview, setExcelPreview] = useState([]);
  const excelInputRef = useRef(null);

  // 活動分享相關狀態
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedShareActivity, setSelectedShareActivity] = useState(null);
  const [allStores, setAllStores] = useState([]); // 所有社別列表
  const [sharedStores, setSharedStores] = useState([]); // 已分享的社別列表
  const [loadingShare, setLoadingShare] = useState(false);

  // 下載活動篩選 Modal 狀態
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadFilters, setDownloadFilters] = useState({
    storeId: 'all', // 'all' 或特定社團 ID
    startDate: '',
    endDate: ''
  });
  const [isDownloading, setIsDownloading] = useState(false);

  // useEffect(() => {
  //   fetchActivities();
  // }, [fetchActivities]); // 確認 fetchActivities 是否是穩定的依賴，否則可能需要使用 useCallback。

  const fetchActivities = async (
    page = 1,
    sortKey = "a_id",
    sortDirection = "desc",
    filter = "",
    isSelf = false,
    e_ssid = user?.e_ssid,
    timeFilterParam = "future",
    categoryFilterParam = ""
  ) => {
    setLoading(true);

    try {
      // 使用智能 API 自動選擇合適的端點
      const params = {
        filter,
        sortKey,
        sortDirection,
        page,
        self: isSelf ? 'true' : 'false',
        e_ssid,
        timeFilter: timeFilterParam,
        categoryFilter: categoryFilterParam
      };
      const response = await getActivities(params);

      // 處理不同的 API 回傳格式
      let data;
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data && response.data.activity && Array.isArray(response.data.activity)) {
        // 如果回傳格式是 { activity: [...], lecturers: [...], visits: [...] }
        data = response.data.activity;
      } else if (response.data && Array.isArray(response.data)) {
        data = response.data;
      } else {
        data = [];
      }

      setActivities((prevActivities) => (page === 1 ? data : [...prevActivities, ...data]));
      setHasMore(data.length > 0);
    } catch (error) {
      // 確保發生錯誤時 activities 仍是陣列
      if (page === 1) {
        setActivities([]);
      }
    }
    setLoading(false);
  };

  const handleEmployeeSearch = async (value) => {
    setFormData({ ...formData, a_eid_name: value }); 
    if (value && value.length >= 1) {
      try {
        const response = await axios.get("/employees/for-assignment", {
          headers: { Authorization: `Bearer ${token.current}` },
          params: { filter: value, limit: 50 }
        });
        
        if (response.data.success) {
          setFilteredEmployees(response.data.data);
          setShowEmployeeSuggestions(true);
        }
      } catch (error) {
        console.error('搜尋負責人失敗:', error);
        setFilteredEmployees([]);
        setShowEmployeeSuggestions(false);
      }
    } else {
      setFilteredEmployees([]);
      setShowEmployeeSuggestions(false);
    }
  };
  const handleUploadSuccess = (fileName) => {
    setFormData((prev) => ({ ...prev, a_EDM: fileName }));
  };
  
  const handleRemoveSuccess = () => {
    setFormData((prev) => ({ ...prev, a_EDM: "" }));
  };
  const handleEmployeeSelect = (employee) => {
    setFormData({ ...formData, a_eid: employee.e_id, a_eid_name: employee.e_name });
    setShowEmployeeSuggestions(false);
  };

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowLecturerSuggestions(true);

    if (value) {
      try {
        setLoadingLecturers(true);
        const response = await axios.get("/lecturers", {
          headers: { Authorization: `Bearer ${token.current}` },
          params: {
            filter: value, 
          },
        });
        setLecturers(response.data); 
      } catch (error) {
        // Handle error silently
      } finally {
        setLoadingLecturers(false);
      }
    } else {
      setLecturers([]);
      setShowLecturerSuggestions(false);
    }
  };

  const handleLecturerSelect = (lecturer) => {
    setSearchTerm(lecturer.l_name);  
    setTopics({ ...topics, t_lid: lecturer.l_id });  
    setShowLecturerSuggestions(false);  
  };

  const openLecturerModal = (activity) => {
    setSelectedActivity(activity); 
    setShowLecturerModal(true);    
  };

  const handleAddLecturerTopic = async () => {
    if (!selectedActivity?.a_id) {
      return;
    }
    try {
      await axios.post(
        `/topics`,
        {
          t_aid: selectedActivity.a_id,
          t_lid: topics.t_lid,
          t_name: topics.t_name,
          t_ssid: user?.e_ssid,
          t_group: 1,
          t_date: selectedActivity.a_date
        },
        {
          headers: { Authorization: `Bearer ${token.current}` },
        }
      );
  
      setSuccessMessage("講師主題已成功新增！");
      setShowLecturerModal(false);
      // 重新抓取活動列表時，要確保參數完整
      fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter); 
      setTimeout(() => setSuccessMessage(""), 3000); 
    } catch (error) {
      setErrorMessage("新增講師主題失敗");
    }
  };

  const handleCompanySearchChange = async (e) => {
    const value = e.target.value;
    setSearchCompanyTerm(value);
    setShowCompanySuggestions(true);

    if (value) {
      try {
        const response = await axios.get("/companies", {
          headers: { Authorization: `Bearer ${token.current}` },
          params: {
            filter: value,
          },
        });
        setCompanies(response.data); 
      } catch (error) {
        // Handle error silently
      }
    } else {
      setCompanies([]);
      setShowCompanySuggestions(false);
    }
  };

  const getTaipeiTime = () => {
    return new Date()
      .toLocaleString("sv-SE", { timeZone: "Asia/Taipei" })
      .replace("T", " ");
  };

  const a_edit_day = getTaipeiTime();
  const v_edit_day = getTaipeiTime();

  const handleCompanySelect = (company) => {
    setSearchCompanyTerm(company.s_com_name); 
    setVisitDetails({ ...visitDetails, v_sid: company.s_id });  
    setShowCompanySuggestions(false);  
  };

  const openCompanyModal = (activity) => {
    setSelectedActivity(activity);  
    setShowCompanyModal(true);      
  };

  // 開啟下載 Modal
  const openDownloadModal = () => {
    setShowDownloadModal(true);
    // 載入所有社團列表（如果還沒載入）
    if (allStores.length === 0) {
      fetchAllStores();
    }
  };

  // 獲取所有社團
  const fetchAllStores = async () => {
    try {
      const response = await axios.get('/stores', {
        headers: { Authorization: `Bearer ${token.current}` }
      });
      setAllStores(response.data || []);
    } catch (error) {
      console.error('獲取社團列表失敗:', error);
    }
  };

  // Excel 下載處理（帶篩選條件）
  const handleDownloadExcel = async () => {
    try {
      setIsDownloading(true);
      
      // 準備查詢參數
      const params = new URLSearchParams();
      if (downloadFilters.storeId !== 'all') {
        params.append('storeId', downloadFilters.storeId);
      }
      if (downloadFilters.startDate) {
        params.append('startDate', downloadFilters.startDate);
      }
      if (downloadFilters.endDate) {
        params.append('endDate', downloadFilters.endDate);
      }

      const response = await axios.get(`/activities/export?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token.current}`,
        },
        responseType: 'blob',
      });

      // 建立下載連結
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // 生成檔名
      let fileName = '活動資料';
      if (downloadFilters.storeId !== 'all') {
        const store = allStores.find(s => s.ss_id == downloadFilters.storeId);
        if (store) fileName += `_${store.ss_name}`;
      }
      if (downloadFilters.startDate || downloadFilters.endDate) {
        fileName += `_${downloadFilters.startDate || '起'}_${downloadFilters.endDate || '迄'}`;
      }
      fileName += `_${new Date().toISOString().slice(0, 10)}.xlsx`;
      
      link.setAttribute('download', fileName);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
      
      setSuccessMessage('活動資料下載成功！');
      setTimeout(() => setSuccessMessage(""), 3000);
      setShowDownloadModal(false);
      
      // 重置篩選條件
      setDownloadFilters({
        storeId: 'all',
        startDate: '',
        endDate: ''
      });
    } catch (error) {
      console.error('下載失敗:', error);
      let errorMsg = '下載失敗，請稍後再試';
      if (error.response?.status === 403) {
        errorMsg = '權限不足：只有秘書才能下載活動資料';
      } else if (error.response?.status === 401) {
        errorMsg = '請重新登入後再試';
      }
      setErrorMessage(errorMsg);
      setTimeout(() => setErrorMessage(""), 5000);
    } finally {
      setIsDownloading(false);
    }
  };

  // Excel 檔案選擇處理
  const handleExcelFileChange = async (event) => {
    const file = event.target.files[0];
    setExcelFile(file);
    setExcelData([]);
    setExcelPreview([]);

    if (!file) return;

    try {
      setIsProcessingExcel(true);
      const result = await handleExcelFileUpload(file);
      
      if (result.success) {
        setExcelData(result.data);
        setExcelPreview(result.data.slice(0, 5)); // 只顯示前5筆預覽
        setSuccessMessage(result.message);
        setTimeout(() => setSuccessMessage(""), 3000);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => setErrorMessage(""), 5000);
      // 清除檔案選擇
      if (excelInputRef.current) {
        excelInputRef.current.value = '';
      }
    } finally {
      setIsProcessingExcel(false);
    }
  };

  // Excel 匯入確認處理
  const handleExcelImport = async () => {
    if (!excelData || excelData.length === 0) {
      setErrorMessage("沒有要匯入的資料");
      return;
    }

    try {
      setIsProcessingExcel(true);
      const result = await uploadActivitiesData(excelData, token.current);
      
      if (result.success) {
        const formattedMessage = formatImportResults(result.data);
        setSuccessMessage(formattedMessage);
        
        // 重新載入活動列表
        fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter);
        
        // 關閉 modal 和清理狀態
        setShowExcelImportModal(false);
        setExcelFile(null);
        setExcelData([]);
        setExcelPreview([]);
        if (excelInputRef.current) {
          excelInputRef.current.value = '';
        }
        
        setTimeout(() => setSuccessMessage(""), 8000); // 延長顯示時間以便閱讀詳細結果
      } else {
        setErrorMessage(result.message);
        setTimeout(() => setErrorMessage(""), 5000);
      }
    } catch (error) {
      setErrorMessage("匯入失敗，請稍後再試");
      setTimeout(() => setErrorMessage(""), 5000);
    } finally {
      setIsProcessingExcel(false);
    }
  };

  // 開啟 Excel 匯入 Modal
  const openExcelImportModal = () => {
    setShowExcelImportModal(true);
    setExcelFile(null);
    setExcelData([]);
    setExcelPreview([]);
    if (excelInputRef.current) {
      excelInputRef.current.value = '';
    }
  };

  const handleAddVisitCompany = async () => {
    if (!selectedActivity?.a_id) {
      return;
    }
    try {
      await axios.post(
        `/visits`,
        {
          v_aid: selectedActivity.a_id,
          v_sid: visitDetails.v_sid,
          v_name: selectedActivity.a_name,
          v_ssid: user?.e_ssid,
          v_group: selectedActivity?.a_group || 1,
          v_remark: visitDetails.v_remark || "",
          v_date: selectedActivity.a_date,
          v_edit_uid: user?.e_id,
          v_edit_day: getTaipeiTime(),
          v_status: 0,
        },
        {
          headers: { Authorization: `Bearer ${token.current}` },
        }
      );

      setSuccessMessage("參訪公司已成功新增！");
      setShowCompanyModal(false);

      // 同樣在重新抓取活動時補齊參數
      fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter); 
      setTimeout(() => setSuccessMessage(""), 3000); 

    } catch (error) {
      setErrorMessage("新增參訪公司失敗");
    }
  };

  const fetchAdditionalData = async () => {
    setLoading(true);
    try {
      const mainactResponse = await axios.get("/mainacts", {
        headers: { Authorization: `Bearer ${token.current}` },
      });

      const storeResponse = await axios.get("/stores", {
        headers: { Authorization: `Bearer ${token.current}` },
      });

      const employeeResponse = await axios.get("/employees", {
        headers: { Authorization: `Bearer ${token.current}` },
        params: { limit: 100 },
      });

      setMainActs(mainactResponse.data);
      setStores(storeResponse.data);
      setEmployees(employeeResponse.data.data); 
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 初始及後續改變 page、filter、sort、timeFilter、categoryFilter 時都帶入完整參數
    fetchActivities(page, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter);
    fetchAdditionalData();
  }, [page, filter, sortConfig, isSelf, user?.e_ssid, timeFilter, categoryFilter]); 

  const handleDelete = async (id) => {
    if (window.confirm("確定要刪除這條活動嗎？")) {
      try {
        const response = await axios.delete(`/activities/${id}`, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
  
        setActivities((prevActivities) =>
          prevActivities.filter((a) => a.a_id !== id)
        );
  
        setSuccessMessage(response.data.message);
        setTimeout(() => setSuccessMessage(""), 3000); 
  
        // 再次載入活動列表時，補足必要參數
        fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter);
  
      } catch (error) {
        setErrorMessage("刪除活動失敗，請稍後再試");
        setTimeout(() => setErrorMessage(""), 3000); 
      }
    }
  };

  const handleActivityToggle = async (activityId, currentStopStatus) => {
    if (currentStopStatus === 1) {
      // 如果已經異動，不執行任何操作
      return;
    }

    if (window.confirm("確定要異動此活動嗎？異動後將停止報名和請假功能。")) {
      try {
        const response = await axios.put(`/activities/${activityId}/toggle`, {}, {
          headers: { Authorization: `Bearer ${token.current}` },
        });

        // 更新活動列表中的 a_stop 狀態
        setActivities((prevActivities) =>
          prevActivities.map((activity) =>
            activity.a_id === activityId 
              ? { ...activity, a_stop: 1 }
              : activity
          )
        );

        setSuccessMessage("活動已異動，停止報名和請假功能");
        setTimeout(() => setSuccessMessage(""), 3000);

      } catch (error) {
        setErrorMessage("異動活動失敗，請稍後再試");
        setTimeout(() => setErrorMessage(""), 3000);
      }
    }
  };

  // 打開分享 Modal
  const openShareModal = async (activity) => {
    setSelectedShareActivity(activity);
    setShowShareModal(true);
    setLoadingShare(true);

    try {
      // 獲取所有社別列表
      const storesResponse = await axios.get('/lecturer-stores', {
        headers: { Authorization: `Bearer ${token.current}` },
      });
      setAllStores(storesResponse.data);

      // 獲取該活動已分享的社別
      const sharedResponse = await axios.get(`/activity_store/${activity.a_id}`, {
        headers: { Authorization: `Bearer ${token.current}` },
      });
      setSharedStores(sharedResponse.data);

      setLoadingShare(false);
    } catch (error) {
      console.error('獲取分享資料失敗:', error);
      setErrorMessage('獲取分享資料失敗');
      setTimeout(() => setErrorMessage(''), 3000);
      setLoadingShare(false);
    }
  };

  // 切換分享狀態（添加或移除分享）
  const toggleShareStore = async (storeId) => {
    if (!selectedShareActivity) return;

    const activityId = selectedShareActivity.a_id;
    const isShared = sharedStores.some(s => s.as_ssid === storeId);

    try {
      if (isShared) {
        // 移除分享
        await axios.delete(`/activity_store/${activityId}/${storeId}`, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        setSharedStores(sharedStores.filter(s => s.as_ssid !== storeId));
        setSuccessMessage('已取消分享');
      } else {
        // 添加分享
        const response = await axios.post(
          '/activity_store',
          { as_aid: activityId, as_ssid: storeId },
          { headers: { Authorization: `Bearer ${token.current}` } }
        );

        // 重新獲取已分享列表
        const sharedResponse = await axios.get(`/activity_store/${activityId}`, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        setSharedStores(sharedResponse.data);
        setSuccessMessage('分享成功');
      }
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('更新分享狀態失敗:', error);
      setErrorMessage('更新分享狀態失敗');
      setTimeout(() => setErrorMessage(''), 3000);
    }
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    
    try {
      // 處理不同的日期格式
      let dateString = dateStr.toString().trim();
      
      // 如果已經包含時間但沒有 T，添加 T
      if (dateString.includes(' ') && !dateString.includes('T')) {
        dateString = dateString.replace(' ', 'T');
      }
      // 如果只有日期沒有時間，添加默認時間
      else if (!dateString.includes(' ') && !dateString.includes('T')) {
        dateString += 'T00:00:00';
      }
      
      const parsedDate = new Date(dateString);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    } catch (error) {
      return null;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    
    // 使用台灣時區格式化日期
    return date.toLocaleString("sv-SE", { 
      timeZone: "Asia/Taipei",
      year: 'numeric',
      month: '2-digit', 
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).replace('T', ' ');
  };

  const handleDateChange = (field, date) => {
    if (!date) {
      setFormData({ ...formData, [field]: "" });
      return;
    }
  
    // 直接用本地時間，假設你要存 "YYYY-MM-DD HH:mm:ss" 就自己 format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  
    setFormData(prev => ({ ...prev, [field]: formattedDate }));
  };

  // react-datepicker 開了 showTimeSelect 後，選日期跟選時間是分開觸發 onChange 的，
  // 若在 onChange 當下就複製到其他日期欄位，會複製到「時間還沒選定」的中繼值。
  // 改在日期選擇器關閉時（使用者已選定日期與時間）才複製到其他空白欄位。
  const handleActivityDateCalendarClose = () => {
    setFormData(prev => {
      if (!prev.a_date) return prev;
      return {
        ...prev,
        a_date_over: prev.a_date_over || prev.a_date,
        a_Sdate: prev.a_Sdate || prev.a_date,
        a_Edate: prev.a_Edate || prev.a_date
      };
    });
  };


  const openModal = (activity = null) => {
    if (activity) {
      setFormData({
        ...Object.fromEntries(
          Object.entries(activity).map(([key, value]) => [
            key,
            // 保持日期的原始格式，不要在這裡格式化
            // formatDate 只用於顯示，parseDate 會處理原始日期字符串
            value ?? ""
          ])
        ),
        a_notify: Number(activity.a_notify) === 1 ? 1 : 0,
        a_eid_name: activity.employee_name || "",
      });
    } else {
      // 新增模式時，保留用戶的社別和基本資訊
      const formDataWithUserInfo = {
        ...initialFormData,
        a_ssid: user?.e_ssid || "",
        a_eid: isSelf ? user?.e_id || "" : "",
        a_eid_name: isSelf ? user?.e_name || "" : ""
      };

      setFormData(formDataWithUserInfo);
    }
    setSelectedActivity(activity);
    setShowModal(true);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    // 重置 activities 並從第一頁重新載入
    setActivities([]);
    setPage(1);
    fetchActivities(1, key, direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setActivities([]);
    setPage(1);
    fetchActivities(1, sortConfig.key, sortConfig.direction, e.target.value, isSelf, user?.e_ssid, timeFilter);
  };

  // 處理時間篩選變更
  const handleTimeFilterChange = (e) => {
    const newTimeFilter = e.target.value;
    setTimeFilter(newTimeFilter);
    setActivities([]);
    setPage(1);
    fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, newTimeFilter, categoryFilter);
  };

  // 處理活動類別篩選變更
  const handleCategoryFilterChange = (e) => {
    const newCategoryFilter = e.target.value;
    setCategoryFilter(newCategoryFilter);
    setActivities([]);
    setPage(1);
    fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, newCategoryFilter);
  };

  useEffect(() => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        setPage((prevPage) => prevPage + 1); 
      }
    });

    if (lastActivityRef.current) {
      observer.current.observe(lastActivityRef.current);
    }
  }, [loading, hasMore]);

  // 自動設定用戶的社別（始終跟隨用戶的 e_ssid，不可更改）
  useEffect(() => {
    if (user?.e_ssid && stores.length > 0) {
      setFormData(prev => ({
        ...prev,
        a_ssid: user.e_ssid,
        a_eid: isSelf ? user.e_id : prev.a_eid,
        a_eid_name: isSelf ? user.e_name : prev.a_eid_name
      }));
    }
  }, [user, stores, isSelf]);

  // 依活動 ID 取主題的函式
  const fetchTopicsByActivity = async (aid, a_date) => {
    try {
      const resp = await axios.get("/topics", {
        headers: { Authorization: `Bearer ${token.current}` },
        params: { a_id: aid }, // 若後端支援，這樣就會只回這場
      });

      let rows = Array.isArray(resp.data) ? resp.data : [];
      // 以 a_id 為主的嚴格過濾，只顯示該活動確實擁有的主題
      let list = rows.filter(r => Number(r.t_aid) === Number(aid));
      // 移除日期備用邏輯，找不到就代表該活動沒有主題，不應該顯示其他活動的主題

      // 去重、清空白與 HTML
      const seen = new Set();
      list = list.filter(r => {
        const lecturer = (r.l_name || r.lecturer_name || "").trim();
        const topic    = normalizeTopic(r.t_name);
        if (!topic) return false;
        const key = `${lecturer}|${topic}`;
        if (seen.has(key)) return false;
        seen.add(key);
        r._lecturer = lecturer;
        r._topic = topic;
        return true;
      });

      // 可依需求排序（先講師後主題）
      list.sort((a,b) => (a._lecturer||'').localeCompare(b._lecturer||'') || a._topic.localeCompare(b._topic));

      // 顯示上限（避免一張 A4 爆掉）
      const MAX = 8;
      const shown = list.slice(0, MAX);
      const topicStr = shown
        .map(r => r._lecturer ? `${r._lecturer}：${r._topic}` : r._topic)
        .join('、')
        + (list.length > MAX ? ` 等共 ${list.length} 則` : '');

      return topicStr;
    } catch (e) {
      return "";
    }
  };

  const normalizeTopic = (raw) => {
    // 轉字串、去 HTML、去 &nbsp;、壓縮空白、收尾空白
    if (Array.isArray(raw)) {
      raw = raw.filter(Boolean).join('、');
    }
    const s = String(raw ?? '')
      .replace(/<[^>]*>/g, '')     // 去 HTML 標籤
      .replace(/&nbsp;/gi, ' ')     // &nbsp; → 空白
      .replace(/\s+/g, ' ')         // 多空白 → 1 格
      .trim();
    // 可能後端回 "null"/"undefined" 字樣
    return (s === 'null' || s === 'undefined') ? '' : s;
  };

  const handleQRCodeClick = async (activity) => {
    const { a_id, a_name, a_date } = activity || {};
    const baseUrl = window.location.origin;
    setQRCodeValue(`${baseUrl}/checkin/mobile?aid=${a_id}&type=10`);
    setActivityName(a_name || '未命名活動');
    const topicStr = await fetchTopicsByActivity(a_id, a_date);
    setLecturerTopics(normalizeTopic(topicStr));
    setShowQRCode(true);
  };

  const loadFont = async (doc) => {
    try {
      // 使用本地的 Source Han Sans TW 字體
      const fontUrl = "/fonts/SourceHanSansTW-Regular.ttf";
      const response = await fetch(fontUrl);
      
      if (!response.ok) {
        throw new Error(`字體文件載入失敗: ${response.status}`);
      }
      
      const fontArrayBuffer = await response.arrayBuffer();
      // 分塊處理大型字體文件，避免堆棧溢出
      const uint8Array = new Uint8Array(fontArrayBuffer);
      let fontBase64 = '';
      const chunkSize = 8192; // 8KB chunks
      for (let i = 0; i < uint8Array.length; i += chunkSize) {
        const chunk = uint8Array.subarray(i, i + chunkSize);
        fontBase64 += String.fromCharCode.apply(null, chunk);
      }
      fontBase64 = btoa(fontBase64);
      
      doc.addFileToVFS("SourceHanSansTW-Regular.ttf", fontBase64);
      doc.addFont("SourceHanSansTW-Regular.ttf", "SourceHanSansTW", "normal");
      doc.setFont("SourceHanSansTW", "normal");
      return true;
    } catch (error) {
      doc.setFont("helvetica");
      return false;
    }
  };

  const downloadPDF = async (nameFromState, topicFromState) => {
    try {
      const doc = new jsPDF();
      const fontLoaded = await loadFont(doc);

      // jsPDF 搭配自訂 CJK 字型時，半形空格會讓編碼流程中斷，
      // 空格後的文字整段消失，改用不斷行空格繞過這個問題
      const escapeSpace = (text) => (text || '').replace(/ /g, ' ');

      let displayName = escapeSpace((nameFromState || '').trim()) || '未命名活動';
      // 再淨化一次，避免 Modal 狀態還沒更新就按下載
      const displayTopic = escapeSpace(normalizeTopic(topicFromState));

      const pageW = doc.internal.pageSize.getWidth();
      const centerX = pageW / 2;

      doc.setFont('SourceHanSansTW','normal');
      doc.setTextColor(0,0,0);
      doc.setFontSize(20);
      doc.text('活動簽到', centerX, 20, { align: 'center' });

      doc.setFontSize(18);
      doc.text('活動名稱:', centerX, 40, { align: 'center' });

      doc.setFontSize(16);
      const wrapWidth = pageW - 40;
      const nameLines = doc.splitTextToSize(displayName, wrapWidth);
      doc.text(nameLines, centerX, 58, { align: 'center' });

      let currentY = 72;
      let qrStartY = 80;
      if (displayTopic) {
        doc.setFontSize(14);
        const topicLines = doc.splitTextToSize(`主題：${displayTopic}`, wrapWidth);
        // 確保每一行都正確置中對齊
        topicLines.forEach((line, index) => {
          doc.text(line, centerX, currentY + (index * 7), { align: 'center' });
        });
        // 根據實際行數把 QR 往下推
        qrStartY = currentY + 10 + (topicLines.length - 1) * 7;
      }

      const qrCanvas = document.getElementById('qrCodeCanvas');
      if (qrCanvas) {
        const qrImageData = qrCanvas.toDataURL('image/png');
        const qrSize = 100;
        const qrX = (pageW - qrSize) / 2;
        doc.addImage(qrImageData, 'PNG', qrX, qrStartY, qrSize, qrSize);
      }

      doc.setFontSize(16);
      // 確保文字能完整顯示，調整位置和使用適當寬度
      const instructionText = '請使用手機掃描此QR-Code進行簽到';
      const instructionY = qrStartY + 110; // 調整 Y 座標位置
      const maxWidth = pageW - 30; // 設定最大寬度，確保文字不會超出頁面
      const textLines = doc.splitTextToSize(instructionText, maxWidth);
      
      // 如果分成多行，逐行顯示
      textLines.forEach((line, index) => {
        doc.text(line, centerX, instructionY + (index * 8), { align: 'center' });
      });

      const safeFileName = displayName.replace(/[<>:"/\\|?*]/g, '').replace(/\s+/g, '_');
      doc.save(`${safeFileName}_QRCode.pdf`);
    } catch (error) {
      alert('PDF 生成失敗，請稍後再試');
    }
  };

  const handleSave = async () => {
    const cleanedFormData = {
      ...formData,
      a_notify: formData.a_notify ? 1 : 0,
      a_ssid: user?.e_ssid,
      a_edit_uid: user?.e_id,
      a_edit_day: getTaipeiTime(),
    };

    try {
      let a_id;
      let updatedActivity;
      const isEditMode = selectedActivity !== null; // 記錄當前是編輯還是新增模式
      
      if (isEditMode) {
        // 更新
        await axios.put(`/activities/${selectedActivity.a_id}`, cleanedFormData, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        a_id = selectedActivity.a_id;
        updatedActivity = { ...selectedActivity, ...cleanedFormData };
      } else {
        // 新增
        const response = await axios.post("/activities", cleanedFormData, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        a_id = response.data.a_id;
        updatedActivity = { ...cleanedFormData, a_id };
      }

      // 更新 selectedActivity 以便後續可以上傳照片
      setSelectedActivity(updatedActivity);
      
      // 對於編輯模式，關閉 Modal；對於新增模式，保持 Modal 開啟以便上傳海報
      if (isEditMode) {
        setShowModal(false);
      }
      
      // 顯示成功訊息
      if (isEditMode) {
        setSuccessMessage("活動已成功更新！");
      } else {
        setSuccessMessage("活動已成功新增！您現在可以上傳海報了。");
      }
      
      // 重新載入活動列表
      fetchActivities(1, sortConfig.key, sortConfig.direction, filter, isSelf, user?.e_ssid, timeFilter, categoryFilter);
      
      // 3秒後清除成功訊息
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      // 顯示用戶友善的錯誤訊息
      let errorMessage = selectedActivity ? "更新活動失敗" : "新增活動失敗";
      if (error.response?.data?.error) {
        errorMessage += `: ${error.response.data.error}`;
      } else if (error.message) {
        errorMessage += `: ${error.message}`;
      }
      
      setErrorMessage(errorMessage);
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  const openQuestionModal = async (activity) => {
    setSelectedActivity(activity);
    setShowQuestionModal(true);
    
    try {
      const response = await axios.get(`/questions/${activity.a_id}`, {
        headers: { Authorization: `Bearer ${token.current}` },
      });
      setSelectedActivityQuestions(response.data);
    } catch (error) {
      // Handle error silently
    }
  };

  const handleSaveQuestion = async () => {
    if (!selectedActivity) return;
    const { a_id } = selectedActivity;

    // ⚠️ 驗證：選擇題必須有至少一個非空選項
    if (newQuestion.q_type === "2") {
      const validOptions = newQuestion.options.filter(opt => opt && opt.trim() !== "");
      if (validOptions.length === 0) {
        alert("❌ 選擇題必須至少有一個選項");
        return;
      }
    }

    try {
      const optionsToSave = newQuestion.q_type === "2"
        ? newQuestion.options.filter(opt => opt && opt.trim() !== "")
        : [];

      console.log("💾 [保存問題] newQuestion 狀態:", newQuestion);
      console.log("📤 [保存問題] 即將提交的選項:", optionsToSave);

      if (editingQuestion) {
        // 更新既有題目
        const dataToSend = {
          q_type: newQuestion.q_type,
          q_text: newQuestion.q_text,
          options: optionsToSave
        };
        console.log("🚀 [PUT] 提交數據到後端:", dataToSend);
        await axios.put(`/questions/${editingQuestion.q_id}`, dataToSend, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
      } else {
        // 新增新題目
        await axios.post(`/questions`, {
          a_id: a_id,
          q_type: newQuestion.q_type,
          q_text: newQuestion.q_text,
          options: optionsToSave
        }, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
      }

      setNewQuestion({ q_text: "", q_type: "1", options: [""] });
      setEditingQuestion(null);

      const response = await axios.get(`/questions/${a_id}`, {
        headers: { Authorization: `Bearer ${token.current}` },
      });
      setSelectedActivityQuestions(response.data);

    } catch (error) {
      // Handle error silently
    }
  };

  const handleDeleteQuestion = async (q_id) => {
    if (!selectedActivity) return;
    const { a_id } = selectedActivity;

    if (window.confirm("確定要刪除此題目嗎？")) {
      try {
        await axios.delete(`/questions/${q_id}`, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        const response = await axios.get(`/questions/${a_id}`, {
          headers: { Authorization: `Bearer ${token.current}` },
        });
        setSelectedActivityQuestions(response.data);
      } catch (error) {
        // Handle error silently
      }
    }
  };

  // RWD 樣式
  const mobileStyles = `
    /* RWD: 手機版 Modal 表單樣式 */
    @media (max-width: 768px) {
      .modal .form-label {
        font-size: 16px !important;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .modal .form-control,
      .modal .form-select {
        font-size: 16px !important;
        padding: 12px !important;
        min-height: 48px;
      }
      .modal .form-group,
      .modal .mb-3 {
        margin-bottom: 20px !important;
      }
      .modal-body {
        padding: 20px !important;
      }
      .modal-footer .btn {
        font-size: 16px !important;
        padding: 12px 24px !important;
        min-height: 48px;
      }
      .list-group-item {
        font-size: 16px !important;
        padding: 12px !important;
      }
    }
  `;

  return (
    <div className="container-fluid mt-4" style={{ padding: isMobile ? '12px' : '20px' }}>
      <style>{mobileStyles}</style>

      {successMessage && (
        <div className="alert alert-success" role="alert">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="alert alert-danger" role="alert">
          {errorMessage}
        </div>
      )}

      {/* 搜尋框與篩選 */}
      <Row className="mb-3 g-2">
        <Col xs={12} md={5}>
          <Form.Control
            type="text"
            placeholder={isMobile ? "搜尋活動..." : "搜尋活動名稱..."}
            value={filter}
            onChange={handleFilterChange}
            className={isMobile ? 'form-control-lg' : ''}
            style={{
              padding: isMobile ? '12px' : '10px',
              fontSize: isMobile ? '16px' : '14px'
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <Form.Select
            value={timeFilter}
            onChange={handleTimeFilterChange}
            className={isMobile ? 'form-control-lg' : ''}
            style={{
              padding: isMobile ? '12px' : '10px',
              fontSize: isMobile ? '16px' : '14px'
            }}
          >
            <option value="all">📋 全部時間</option>
            <option value="future">🔜 未來活動</option>
            <option value="past">📅 過去活動</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={4}>
          <Form.Select
            value={categoryFilter}
            onChange={handleCategoryFilterChange}
            className={isMobile ? 'form-control-lg' : ''}
            style={{
              padding: isMobile ? '12px' : '10px',
              fontSize: isMobile ? '16px' : '14px'
            }}
          >
            <option value="">🏷️ 全部類別</option>
            {mainActs.map((act) => (
              <option key={act.am_id} value={act.am_id}>
                {act.am_name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {/* 按鈕群組 */}
      {canEditRole && (
        <Row className="mb-3 g-2">
          <Col xs={12} md={4}>
            <Button
              variant="success"
              onClick={() => openModal()}
              className="w-100"
              size={isMobile ? 'lg' : 'md'}
            >
              新增活動
            </Button>
          </Col>
          <Col xs={6} md={4}>
            <Button
              variant="info"
              onClick={openDownloadModal}
              disabled={isProcessingExcel}
              className="w-100"
              size={isMobile ? 'lg' : 'md'}
            >
              📥 下載活動
            </Button>
          </Col>
          {canImportActivities && (
            <Col xs={6} md={4}>
              <Button
                variant="warning"
                onClick={openExcelImportModal}
                disabled={isProcessingExcel}
                className="w-100"
                size={isMobile ? 'lg' : 'md'}
              >
                📤 匯入活動
              </Button>
            </Col>
          )}
        </Row>
      )}

      {/* 手機版：卡片視圖 */}
      {isMobile ? (
        <div>
          {activities.map((activity, index) => (
            <Card
              key={activity.a_id}
              className="mb-3 shadow-sm"
              ref={index === activities.length - 1 ? lastActivityRef : null}
            >
              <Card.Body>
                <Row>
                  <Col xs={4} className="text-center">
                    {activity.a_EDM ? (
                      <img
                        src={`/uploads/AEDM/${activity.a_EDM}?t=${new Date().getTime()}`}
                        alt="活動 EDM"
                        style={{
                          width: '100%',
                          maxWidth: '100px',
                          height: '120px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setLightboxImage(`/uploads/AEDM/${activity.a_EDM}?t=${new Date().getTime()}`);
                          setIsLightboxOpen(true);
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '100%',
                        maxWidth: '100px',
                        height: '120px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        color: '#999'
                      }}>
                        無圖片
                      </div>
                    )}
                  </Col>
                  <Col xs={8}>
                    <h6 className="mb-2">
                      <Badge bg="primary">#{activity.a_id}</Badge>{' '}
                      <strong>{activity.a_name || '未命名活動'}</strong>
                    </h6>
                    <div className="mb-1">
                      <small className="text-muted">社別：</small>
                      <span className="ms-1">{activity.store_name || '未設定'}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">類別：</small>
                      <span className="ms-1">{activity.mainact_name || '未設定'}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">日期：</small>
                      <span className="ms-1">{formatDate(activity.a_date)}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">負責人：</small>
                      <span className="ms-1">{activity.employee_name || '未設定'}</span>
                    </div>
                    {activity.lecturer_topics && (
                      <div className="mb-1">
                        <small className="text-muted">講師：</small>
                        <span className="ms-1">{activity.lecturer_topics}</span>
                      </div>
                    )}
                    {activity.a_notify === 1 && (
                      <div className="mb-1">
                        <span className="badge bg-success">🔔 已開啟提醒</span>
                      </div>
                    )}
                    {activity.company_names && (
                      <div className="mb-1">
                        <small className="text-muted">參訪：</small>
                        <span className="ms-1">{activity.company_names}</span>
                      </div>
                    )}
                  </Col>
                </Row>

                {/* 操作按鈕 */}
                <Row className="mt-3 g-2">
                  <Col xs={6}>
                    <Button
                      variant="warning"
                      size="lg"
                      className="w-100"
                      onClick={() => navigateToNewPage(activity.a_id)}
                    >
                      📝 報名
                    </Button>
                  </Col>
                  {canEditRole && (
                    <>
                      <Col xs={6}>
                        <Button
                          variant="info"
                          size="lg"
                          className="w-100"
                          onClick={() => openModal(activity)}
                        >
                          ✏️ 編輯
                        </Button>
                      </Col>
                      <Col xs={4}>
                        <Button
                          variant="warning"
                          size="sm"
                          className="w-100"
                          onClick={() => handleQRCodeClick(activity)}
                        >
                          QR
                        </Button>
                      </Col>
                      <Col xs={4}>
                        <Button
                          variant="success"
                          size="sm"
                          className="w-100"
                          onClick={() => openShareModal(activity)}
                        >
                          分享
                        </Button>
                      </Col>
                      <Col xs={4}>
                        <Button
                          variant="danger"
                          size="sm"
                          className="w-100"
                          onClick={() => handleDelete(activity.a_id)}
                        >
                          刪除
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button
                          variant="primary"
                          size="sm"
                          className="w-100"
                          onClick={() => openQuestionModal(activity)}
                        >
                          ❓ 問題
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button
                          variant={activity.a_stop === 1 ? "secondary" : "dark"}
                          size="sm"
                          className="w-100"
                          onClick={() => handleActivityToggle(activity.a_id, activity.a_stop)}
                          disabled={activity.a_stop === 1}
                        >
                          {activity.a_stop === 1 ? "已異動" : "⚡ 異動"}
                        </Button>
                      </Col>
                    </>
                  )}
                </Row>
              </Card.Body>
            </Card>
          ))}
          {loading && (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
              <div className="mt-2">載入中...</div>
            </div>
          )}
        </div>
      ) : (
        // 桌面版：表格視圖
        <Table
          striped
          bordered
          hover
          variant="dark"
          className="table-striped table-dark"
        >
          <thead>
            <tr>
              <th style={{ width: '10px' }} onClick={() => handleSort("a_id")}>編號</th>
              <th onClick={() => handleSort("ss_name")}>負責人</th>
              <th onClick={() => handleSort("e_name")}>社別</th>
              <th onClick={() => handleSort("am_name")}>活動類別</th>
              <th onClick={() => handleSort("a_name")}>活動名稱</th>
              <th onClick={() => handleSort("a_date")}>活動日期</th>
              <th onClick={() => handleSort("a_date")}>活動相片</th>
              <th onClick={() => handleSort("lecturer_topics")}>講師主題</th>
              <th onClick={() => handleSort("company_names")}>參訪公司</th>
              <th>提醒</th>
              {/* <th onClick={() => handleSort("a_people")}>人數限制</th>
              <th onClick={() => handleSort("a_location")}>地點</th> */}
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
          {activities.map((activity, index) => (
            <tr
              key={activity.a_id}
              ref={index === activities.length - 1 ? lastActivityRef : null}
            >
              <td>{activity.a_id}</td>
              <td>{activity.employee_name}</td>
              <td>{activity.store_name}</td>
              <td>{activity.mainact_name}</td>
              <td>{activity.a_name}</td>
              <td>{formatDate(activity.a_date)}</td>
              <td>
        {/* EDM 照片預覽 */}
        {activity.a_EDM && (
              <img
                src={`/uploads/AEDM/${activity.a_EDM}?t=${new Date().getTime()}`}
                alt="活動 EDM"
                style={{
                  width: 100,
                  height: 120,
                  cursor: 'pointer',
                  borderRadius: 8,
                }}
                onClick={() => {
                  setLightboxImage(`/uploads/AEDM/${activity.a_EDM}?t=${new Date().getTime()}`);
                  setIsLightboxOpen(true);
                }}
              />
            )}
      </td>
              <td>
                {activity.lecturer_topics}
                {canEditRole &&  (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => openLecturerModal(activity)}
                    className="ml-2"
                  >
                    +
                  </Button>
                )}
              </td>
              <td>
                {activity.company_names}
                {canEditRole &&  (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => openCompanyModal(activity)}
                    className="ml-2"
                  >
                    +
                  </Button>
                )}
              </td>
              <td className="text-center">
                {activity.a_notify === 1
                  ? <span className="badge bg-success">🔔</span>
                  : <span className="badge bg-secondary">🔕</span>}
              </td>
              {/* <td>{activity.a_people}</td>
              <td>{activity.a_location}</td> */}
              <td>
                {canEditRole && (
                  <>
                    <Button variant="info" onClick={() => openModal(activity)}>
                      編輯
                    </Button>
<Button variant="primary" onClick={() => openQuestionModal(activity)}>
  問題
</Button>

                    <Button variant="danger" onClick={() => handleDelete(activity.a_id)}>
                      刪除
                    </Button>
                    <Button variant="warning" onClick={() => handleQRCodeClick(activity)}>
                      QR
                    </Button>
                    <Button
                      variant={activity.a_stop === 1 ? "secondary" : "dark"}
                      onClick={() => handleActivityToggle(activity.a_id, activity.a_stop)}
                      disabled={activity.a_stop === 1}
                    >
                      {activity.a_stop === 1 ? "已異動" : "異動"}
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => openShareModal(activity)}
                    >
                      分享
                    </Button>
                  </>
                )}
                <Button variant="warning" onClick={() => navigateToNewPage(activity.a_id)}>
                  報名
                </Button>
              </td>
            </tr>
          ))}
          {loading && (
            <tr>
              <td colSpan="9" className="text-center">
                加載中...
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      )}

      <Modal
        show={showQRCode}
        onHide={() => setShowQRCode(false)}
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {qrCodeValue && (
            <div>
              <QRCodeCanvas id="qrCodeCanvas" value={qrCodeValue} size={256} />
              <p>活動名稱: {activityName}</p>
              {lecturerTopics && <p>講師主題: {lecturerTopics}</p>}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQRCode(false)}>
            關閉
          </Button>
          <Button variant="primary" onClick={() => downloadPDF(activityName, lecturerTopics)}>
            下載 PDF
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 活動分享 Modal */}
      <Modal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        size="lg"
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            分享活動：{selectedShareActivity?.a_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingShare ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">載入中...</p>
            </div>
          ) : (
            <div>
              <p className="text-muted">
                選擇要分享給的社別（活動所屬社別：{selectedShareActivity?.store_name}）
              </p>
              <div className="row">
                {allStores
                  .filter(store => store.ss_id !== selectedShareActivity?.a_ssid)
                  .map(store => {
                    const isShared = sharedStores.some(s => s.as_ssid === store.ss_id);
                    return (
                      <div key={store.ss_id} className="col-md-4 mb-3">
                        <Button
                          variant={isShared ? "success" : "outline-secondary"}
                          className="w-100"
                          onClick={() => toggleShareStore(store.ss_id)}
                        >
                          {store.ss_name}
                          {isShared && ' ✓ 已分享'}
                        </Button>
                      </div>
                    );
                  })}
              </div>
              {sharedStores.length > 0 && (
                <div className="mt-3">
                  <h6>已分享給 {sharedStores.length} 個社別</h6>
                  <div className="text-muted">
                    {sharedStores.map(s => s.ss_name || `社別${s.as_ssid}`).join(', ')}
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowShareModal(false)}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLecturerModal}
        onHide={() => setShowLecturerModal(false)}
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>新增講師主題</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>搜尋講師</Form.Label>
            <Form.Control
              type="text"
              placeholder="輸入講師名稱"
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={() => setShowLecturerSuggestions(true)}
            />
          </Form.Group>

          {errorMessage && <div className="alert alert-danger mt-2">{errorMessage}</div>}

          {loadingLecturers && (
            <div className="d-flex justify-content-center mt-3">
              <Spinner animation="border" variant="primary" />
              <span className="ml-2">加載中...</span>
            </div>
          )}

          {showLecturerSuggestions && searchTerm && lecturers.length > 0 && !loadingLecturers && (
            <ListGroup>
              {lecturers.map((lecturer) => (
                <ListGroup.Item
                  key={lecturer.l_id}
                  action
                  onClick={() => handleLecturerSelect(lecturer)}
                >
                  {lecturer.l_name}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}

          <Form.Group className="mt-3">
            <Form.Label>主題</Form.Label>
            <Form.Control
              type="text"
              value={topics.t_name}
              onChange={(e) => setTopics({ ...topics, t_name: e.target.value })}
              placeholder="輸入主題"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLecturerModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={handleAddLecturerTopic}>
            新增
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCompanyModal}
        onHide={() => setShowCompanyModal(false)}
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>新增參訪公司</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>搜尋公司</Form.Label>
            <Form.Control
              type="text"
              placeholder="輸入公司名稱"
              value={searchCompanyTerm}
              onChange={handleCompanySearchChange}
              onFocus={() => setShowCompanySuggestions(true)}
            />
          </Form.Group>

          {showCompanySuggestions && searchCompanyTerm && companies.length > 0 && (
            <ListGroup>
              {companies.map((company) => (
                <ListGroup.Item
                  key={company.s_id}
                  action
                  onClick={() => handleCompanySelect(company)}
                >
                  {company.s_com_name}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCompanyModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={handleAddVisitCompany}>
            新增
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showQuestionModal}
        onHide={() => setShowQuestionModal(false)}
        fullscreen={isMobile ? true : false}
      >
  <Modal.Header closeButton>
    <Modal.Title>管理活動問題</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div>
      {selectedActivityQuestions.map((question, index) => (
        <div key={question.q_id} className="mb-3">
          <strong>{index + 1}. {question.q_text} ({question.q_type === 1 ? "問答題" : "選擇題"})</strong>
          {question.q_type === 2 && (
            <ul>
              {question.options.map((option, i) => (
                <li key={option.o_id || i}>{option.o_text}</li>
              ))}
            </ul>
          )}
          <div className="mt-2">
            <Button
              variant="info"
              size="sm"
              onClick={() => {
                // 編輯題目：將 existing question 塞進表單中
                console.log("🔍 [編輯問題] 原始問題數據:", question);
                setEditingQuestion(question);
                const existingOptions = question.q_type === 2 && question.options && question.options.length > 0
                  ? question.options.map(o => o.o_text)
                  : [""];
                console.log("📝 [編輯問題] 載入的選項:", existingOptions);
                setNewQuestion({
                  q_text: question.q_text,
                  q_type: String(question.q_type),
                  options: existingOptions
                });
              }}
            >
              編輯
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="ml-2"
              onClick={() => handleDeleteQuestion(question.q_id)}
            >
              刪除
            </Button>
          </div>
        </div>
      ))}
    </div>

    <hr />
    <h5>{editingQuestion ? "編輯問題" : "新增問題"}</h5>
    <Form.Group className="mb-3">
      <Form.Label>問題內容</Form.Label>
      <Form.Control
        type="text"
        value={newQuestion.q_text}
        onChange={(e) => setNewQuestion({ ...newQuestion, q_text: e.target.value })}
        placeholder="輸入問題內容"
      />
    </Form.Group>
    <Form.Group className="mb-3">
      <Form.Label>問題類型</Form.Label>
      <Form.Control
        as="select"
        value={newQuestion.q_type}
        onChange={(e) => setNewQuestion({ ...newQuestion, q_type: e.target.value })}
      >
        <option value="1">問答題</option>
        <option value="2">選擇題</option>
      </Form.Control>
    </Form.Group>
    {newQuestion.q_type === "2" && (
  <div>
    <Form.Label>選項</Form.Label>
    {newQuestion.options.map((option, i) => (
      <div key={i} className="d-flex mb-2">
        <Form.Control
          type="text"
          value={option}
          onChange={(e) => {
            const updatedOptions = [...newQuestion.options];
            updatedOptions[i] = e.target.value;
            setNewQuestion({ ...newQuestion, options: updatedOptions });
          }}
          placeholder={`選項 ${i + 1}`}
        />
        {i > 0 && (
          <Button
            variant="danger"
            className="ml-2"
            onClick={() => {
              const updatedOptions = newQuestion.options.filter((_, index) => index !== i);
              setNewQuestion({ ...newQuestion, options: updatedOptions });
            }}
          >
            刪除
          </Button>
        )}
      </div>
    ))}
    <Button
      variant="success"
      onClick={() => setNewQuestion({ ...newQuestion, options: [...newQuestion.options, ""] })}
    >
      新增選項
    </Button>
  </div>
)}

  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowQuestionModal(false)}>
      取消
    </Button>
    <Button
      variant="primary"
      onClick={handleSaveQuestion}
    >
      儲存
    </Button>
  </Modal.Footer>
</Modal>


      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          // 如果是新增模式且尚未儲存，清除 selectedActivity
          // 如果已經儲存過，保留 selectedActivity 以便上傳照片
        }}
        fullscreen={isMobile ? true : false}
        size={isMobile ? undefined : 'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? '18px' : '20px' }}>
            {selectedActivity?.a_id ? "編輯活動" : "新增活動"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: isMobile ? '16px' : '14px' }}>
          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>社別</Form.Label>
              <Form.Control
                as="select"
                name="a_ssid"
                value={formData.a_ssid} 
                disabled
                required
              >
                <option value={user?.e_ssid}>
                  {(() => {
                    const userSsid = user?.e_ssid;
                    const matchedStore = stores.find((store) => parseInt(store.ss_id) === parseInt(userSsid));
                    return matchedStore?.ss_name || "未知社別";
                  })()}
                </option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>負責人<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="輸入負責人名稱"
                value={formData.a_eid_name}
                onChange={(e) => handleEmployeeSearch(e.target.value)}
                required
              />
              {!formData.a_eid && <div className="text-danger">請選擇負責人</div>}

              {showEmployeeSuggestions && (
                <ListGroup>
                  {filteredEmployees.map((employee) => (
                    <ListGroup.Item
                      key={employee.e_id}
                      action
                      onClick={() => handleEmployeeSelect(employee)}
                    >
                      {employee.e_name}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>活動類別<span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="select"
                value={formData.a_group}
                onChange={(e) => setFormData({ ...formData, a_group: e.target.value })}
                required
              >
                <option value="">選擇活動類別</option>
                {mainActs.map((act) => (
                  <option key={act.am_id} value={act.am_id}>
                    {act.am_name}
                  </option>
                ))}
              </Form.Control>
              {!formData.a_group && <div className="text-danger">請選擇活動類別</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>活動名稱<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={formData.a_name}
                onChange={(e) => setFormData({ ...formData, a_name: e.target.value })}
                required
              />
              {!formData.a_name && <div className="text-danger">請填寫活動名稱</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>活動日期<span className="text-danger">*</span></Form.Label>
              <DatePicker
                selected={parseDate(formData.a_date)}
                onChange={(date) => handleDateChange("a_date", date)}
                onCalendarClose={handleActivityDateCalendarClose}
                required
                dateFormat="yyyy-MM-dd HH:mm:ss"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="時間"
                className="form-control"
              />
              {!formData.a_date && <div className="text-danger">請選擇活動日期</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>報名結束日期<span className="text-danger">*</span></Form.Label>
              <DatePicker
                selected={parseDate(formData.a_date_over)}
                onChange={(date) => handleDateChange("a_date_over", date)}
                required
                dateFormat="yyyy-MM-dd HH:mm:ss"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="時間"
                className="form-control"
              />
              {!formData.a_date_over && <div className="text-danger">請選擇報名結束日期</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>活動開始日期<span className="text-danger">*</span></Form.Label>
              <DatePicker
                selected={parseDate(formData.a_Sdate)}
                onChange={(date) => handleDateChange("a_Sdate", date)}
                required
                dateFormat="yyyy-MM-dd HH:mm:ss"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="時間"
                className="form-control"
              />
              {!formData.a_Sdate && <div className="text-danger">請選擇活動開始日期</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>活動結束日期<span className="text-danger">*</span></Form.Label>
              <DatePicker
                selected={parseDate(formData.a_Edate)}
                onChange={(date) => handleDateChange("a_Edate", date)}
                required
                dateFormat="yyyy-MM-dd HH:mm:ss"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="時間"
                className="form-control"
              />
              {!formData.a_Edate && <div className="text-danger">請選擇活動結束日期</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>人數<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={formData.a_people}
                onChange={(e) => setFormData({ ...formData, a_people: e.target.value })}
                required
              />
              {!formData.a_people && <div className="text-danger">請填寫人數</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>地點<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={formData.a_location}
                onChange={(e) => setFormData({ ...formData, a_location: e.target.value })}
                required
              />
              {!formData.a_location && <div className="text-danger">請填寫地點</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>預算</Form.Label>
              <Form.Control
                type="text"
                value={formData.a_budget}
                onChange={(e) => setFormData({ ...formData, a_budget: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>備註</Form.Label>
              <Form.Control
                as="textarea"
                value={formData.a_remark}
                onChange={(e) => setFormData({ ...formData, a_remark: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="switch"
                id="notify-switch"
                label={formData.a_notify ? "🔔 已開啟活動前一天提醒" : "🔕 活動提醒（關閉）"}
                checked={!!formData.a_notify}
                onChange={(e) => setFormData({ ...formData, a_notify: e.target.checked ? 1 : 0 })}
              />
              <Form.Text className={formData.a_notify ? "text-success" : "text-muted"}>
                {formData.a_notify
                  ? "系統將在活動前一天早上 8:00 自動發送 LINE 提醒給所有已報名社友"
                  : "開啟後，系統會在活動前一天早上 8:00 透過 LINE 提醒已報名的社友"}
              </Form.Text>
            </Form.Group>

            {/* 上傳照片 - 活動儲存後即可上傳 */}
            {selectedActivity?.a_id ? (
              <div>
                <Form.Label>活動海報上傳</Form.Label>
                <PhotoUpload
                  e_id={selectedActivity.a_id}
                  token={token.current}
                  fileCategory="AEDM"
                  tableName="activity"
                  columnName="a_EDM"
                  idColumn="a_id"
                  onUploadSuccess={handleUploadSuccess}
                  onRemoveSuccess={handleRemoveSuccess}
                  currentFileName={formData.a_EDM}
                  buttonText="上傳海報"
                  onImageClick={(imageUrl) => {
                    setLightboxImage(imageUrl);
                    setIsLightboxOpen(true);
                  }}
                />
              </div>
            ) : (
              <div className="text-muted">
                <Form.Label>活動海報上傳</Form.Label>
                <div>請先儲存活動後才能上傳海報</div>
              </div>
            )}
      {/* 照片預觽功能已整合入 PhotoUpload 元件 */}

{/* Lightbox 圖片預觽 - 設置更高的 z-index 以顯示在 Modal 前面 */}
{isLightboxOpen && (
  <Lightbox
    mainSrc={lightboxImage}
    onCloseRequest={() => setIsLightboxOpen(false)}
    reactModalStyle={{
      overlay: { zIndex: 1060 },
      content: { zIndex: 1061 }
    }}
  />
)}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModal(false);
            // 清除狀態，但不影響已創建的活動
          }}>
            取消
          </Button>
          <Button 
            variant="primary" 
            onClick={handleSave}
          >
            {selectedActivity?.a_id ? "儲存" : "儲存"}
          </Button>
          {selectedActivity?.a_id && (
            <Button 
              variant="secondary" 
              onClick={() => setShowModal(false)}
              className="ms-2"
            >
              完成
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Excel 匯入 Modal */}
      <Modal show={showExcelImportModal} onHide={() => setShowExcelImportModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Excel 活動匯入</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* 使用說明 */}
          <Alert variant="info">
            <h6>📋 匯入說明：</h6>
            <ul className="mb-0">
              <li><strong>新增活動：</strong>活動ID欄位留空或為0</li>
              <li><strong>更新活動：</strong>填入現有的活動ID</li>
              <li><strong>必填欄位：</strong>活動名稱、開始日期、結束日期</li>
              <li><strong>建議：</strong>先下載現有資料作為範本</li>
            </ul>
          </Alert>

          {/* 檔案選擇 */}
          <Form.Group className="mb-3">
            <Form.Label>選擇 Excel 檔案</Form.Label>
            <Form.Control
              ref={excelInputRef}
              type="file"
              accept=".xlsx,.xls"
              onChange={handleExcelFileChange}
              disabled={isProcessingExcel}
            />
            <Form.Text className="text-muted">
              支援 .xlsx 和 .xls 格式，檔案大小限制 10MB
            </Form.Text>
          </Form.Group>

          {/* 處理狀態顯示 */}
          {isProcessingExcel && (
            <div className="text-center mb-3">
              <Spinner animation="border" size="sm" className="me-2" />
              處理中，請稍候...
            </div>
          )}

          {/* 資料預覽 */}
          {excelPreview.length > 0 && (
            <div className="mb-3">
              <h6>📊 資料預覽（前5筆）：</h6>
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>活動ID</th>
                      <th>活動名稱</th>
                      <th>開始日期</th>
                      <th>結束日期</th>
                      <th>地點</th>
                    </tr>
                  </thead>
                  <tbody>
                    {excelPreview.map((row, index) => (
                      <tr key={index}>
                        <td>{row['活動ID'] || '(新增)'}</td>
                        <td>{row['活動名稱']}</td>
                        <td>{row['開始日期']}</td>
                        <td>{row['結束日期']}</td>
                        <td>{row['地點'] || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <small className="text-muted">
                總共 {excelData.length} 筆資料，顯示前 {Math.min(5, excelData.length)} 筆
              </small>
            </div>
          )}

          {/* 成功/錯誤訊息 */}
          {successMessage && (
            <Alert variant="success" className="mb-3">
              {successMessage}
            </Alert>
          )}
          {errorMessage && (
            <Alert variant="danger" className="mb-3">
              {errorMessage}
            </Alert>
          )}
        </Modal.Body>
        
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowExcelImportModal(false)}
            disabled={isProcessingExcel}
          >
            取消
          </Button>
          <Button 
            variant="primary" 
            onClick={handleExcelImport}
            disabled={isProcessingExcel || !excelData.length}
          >
            {isProcessingExcel ? (
              <>
                <Spinner size="sm" className="me-2" />
                匯入中...
              </>
            ) : (
              `確認匯入 (${excelData.length} 筆)`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 下載活動篩選 Modal */}
      <Modal 
        show={showDownloadModal} 
        onHide={() => setShowDownloadModal(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>📥 下載活動資料</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info" className="mb-3">
            <small>
              選擇篩選條件後下載活動資料。不選擇任何條件將下載所有活動。
            </small>
          </Alert>

          <Form>
            {/* 社團選擇 */}
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>社團篩選</strong>
              </Form.Label>
              <Form.Select
                value={downloadFilters.storeId}
                onChange={(e) => setDownloadFilters({
                  ...downloadFilters,
                  storeId: e.target.value
                })}
                disabled={isDownloading}
              >
                <option value="all">全部社團</option>
                {allStores.map(store => (
                  <option key={store.ss_id} value={store.ss_id}>
                    {store.ss_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* 日期區間 */}
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>日期區間</strong>
              </Form.Label>
              <Row>
                <Col xs={6}>
                  <Form.Label className="small">開始日期</Form.Label>
                  <Form.Control
                    type="date"
                    value={downloadFilters.startDate}
                    onChange={(e) => setDownloadFilters({
                      ...downloadFilters,
                      startDate: e.target.value
                    })}
                    disabled={isDownloading}
                  />
                </Col>
                <Col xs={6}>
                  <Form.Label className="small">結束日期</Form.Label>
                  <Form.Control
                    type="date"
                    value={downloadFilters.endDate}
                    onChange={(e) => setDownloadFilters({
                      ...downloadFilters,
                      endDate: e.target.value
                    })}
                    disabled={isDownloading}
                  />
                </Col>
              </Row>
              <Form.Text className="text-muted">
                不選擇日期將下載所有日期的活動
              </Form.Text>
            </Form.Group>

            {/* 預覽選擇的條件 */}
            {(downloadFilters.storeId !== 'all' || downloadFilters.startDate || downloadFilters.endDate) && (
              <Alert variant="success" className="mb-0">
                <small>
                  <strong>即將下載：</strong>
                  <br />
                  {downloadFilters.storeId !== 'all' && (
                    <>社團：{allStores.find(s => s.ss_id == downloadFilters.storeId)?.ss_name || '未知'}<br /></>
                  )}
                  {downloadFilters.startDate && (
                    <>起始：{downloadFilters.startDate}<br /></>
                  )}
                  {downloadFilters.endDate && (
                    <>截止：{downloadFilters.endDate}</>
                  )}
                </small>
              </Alert>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => {
              setShowDownloadModal(false);
              setDownloadFilters({
                storeId: 'all',
                startDate: '',
                endDate: ''
              });
            }}
            disabled={isDownloading}
          >
            取消
          </Button>
          <Button 
            variant="primary" 
            onClick={handleDownloadExcel}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <>
                <Spinner size="sm" className="me-2" />
                下載中...
              </>
            ) : (
              '下載 Excel'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ActivitiesTable;
